var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fill-height":"","align-center":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }